import { render } from "./SegmentsText.vue?vue&type=template&id=99f02f68&scoped=true"
import script from "./SegmentsText.vue?vue&type=script&lang=js"
export * from "./SegmentsText.vue?vue&type=script&lang=js"

import "./SegmentsText.vue?vue&type=style&index=0&id=99f02f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f02f68"]])

export default __exports__